import { useEffect } from "react";

import { useAppDispatch } from "../../store";
import { AuthEventChannel, AuthEventType } from "../shared/enums/auth-events";
import { imsAuthService } from "../shared/ims-auth-service";
import { sessionExpired } from "../store/auth.slice";

export const useAuthEvents = (): void => {
  const dispatch = useAppDispatch();

  useEffect(
    () => imsAuthService.onSessionLost(() => dispatch(sessionExpired())),
    [dispatch]
  );

  useEffect(() => {
    if (typeof BroadcastChannel === "undefined") {
      return;
    }

    const authChannel = new BroadcastChannel(AuthEventChannel.AUTH_EVENTS);

    const handleMessage = (event: MessageEvent) => {
      if (event.data?.type === AuthEventType.LOGOUT_REQUIRED) {
        dispatch(sessionExpired());
      }
    };

    authChannel.addEventListener("message", handleMessage);

    return () => {
      authChannel.removeEventListener("message", handleMessage);
      authChannel.close();
    };
  }, [dispatch]);
};
